// extracted by mini-css-extract-plugin
export default {"tableHeading":"tableHeading____150H_contentrenderer","center":"center___ivVkQ_contentrenderer","right":"right___GLY2M_contentrenderer"};